<template>
    <b-overlay :show="tableLoading" rounded="sm">
        <b-card class="inner-block activity-template">
            <b-card-header>
                <b-col md="12" cols="12" class="query-filter dd">
                    <b-form-select class="mt-3 form-control" id="input-order-item-type" v-model="type"
                        :options="types" text-field="name" value-field="id">
                        <template #first>
                            <b-form-select-option :value="null">
                                {{ $translate('select_any_type') }}
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-row class="mt-2">
                    <b-col cols="12" class="d-flex">
                        <b-input id="search_activity_templates" type="text" :placeholder="$translate('search_activity_templates')"
                            v-model="filter"></b-input>
                        <slot></slot>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-card-body>
                <b-col class="page-block"><strong>
                        {{ $translate('page') }}: {{ currentPage }} {{ $translate('of') }}
                        {{ Math.ceil(rows / itemsPerPage) }} {{ $translate('total') }}:
                        {{ rows }}</strong></b-col>
                <b-col class="overflow-auto w-100 mt-4">
                    <b-table :fields="fields" responsive :items="templates" :per-page="itemsPerPage"
                        :current-page="currentPage" :filter="filter">
                        <template>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <!-- <strong>{{ $translate('loading') }}</strong> -->
                            </div>
                        </template>
                        <template #cell(id)="row">
                            <b-button :id="'view-template-btn-'+row.item.id"  v-if="hasPermissionView" @click="$emit('show-item', row.item.id)" class="me-2 test-view-template-btn"
                                variant="pink-button">
                                <img src="@/assets/images/icon/view.svg" />
                            </b-button>
                        </template>
                    </b-table>
                </b-col>
            </b-card-body>
            <b-row>
                <b-col>
                    <b-pagination class="justify-content-center mt-4" :prev-text="$translate('previous')"
                        :next-text="$translate('next')" v-model="currentPage" :total-rows="rows" :per-page="itemsPerPage"
                        aria-controls="roleTable" pills align="right"></b-pagination>
                </b-col>
            </b-row>
        </b-card>
    </b-overlay>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'activityTemplates-ListItems',
    mixins: [popupMixins, permissionsMixins],
    props: ['title', 'items'],

    data() {
        return {
            types: [
                { id: 1, name: this.$translate('primary_type') },
                { id: 2, name: this.$translate('secondary_type') }
            ],
            type: null,
            filter: '',
            tableLoading: false,
            itemsPerPage: 15,
            currentPage: 1,
        }
    },

    mounted() {
        this.doSearch()
    },
    watch: {
        type: {
            handler: function () {
                this.filterTemplates()
            },
            deep: true,
        },
        templates: {
            handler: function () {
                this.tableLoading = false
            },
            deep: true,
        },
    },

    methods: {
        async doSearch() {
            this.tableLoading = true
            await this.$store.dispatch('orderTemplate/fetchAll')
        },

        filterTemplates(templates) {
            let data
            data = templates
            if (this.type == 1) {
                data = data && data.filter(x => x.type !== null)
            } if (this.type == 2) {
                data = data && data.filter(x => x.secondary_type !== null)
            }
            return data
        },
    },

    computed: {
        fields() {
            return [
                {
                    key: 'id',
                    label: this.$translate('actions'),
                },
                {
                    key: 'name',
                    label: this.$translate('name'),
                },
                {
                    key: 'order_category_id',
                    label: this.$translate('category'),
                    formatter: (value, key, item) => item.category.name,
                },
                {
                    key: 'order_type_id',
                    label: this.$translate('primary_type'),
                    formatter: (value, key, item) => item.type.name,
                },
                {
                    key: 'secondary_order_type_id',
                    label: this.$translate('secondary_type'),
                    formatter: (value, key, item) => item.secondary_type ? item.secondary_type.name : 'N/A',
                },
            ]
        },
        templates() {
            const templates = this.$store.state.orderTemplate.templates
            console.log('templates', templates)
            return this.filterTemplates(templates)
        },
        user() {
            return this.$store.state.user
        },

        rows() {
            return this.templates.length
        },
    },
}
</script>
<style></style>
